// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2bylT","header":"ReportDetails_header__2iB_P","title":"ReportDetails_title__3w5ai","left":"ReportDetails_left__3k0K1"};